import { ENUM_CARGO, ENUM_STATUS_IS_SETORIAL } from 'utils/consts';
import { ENUM_PERMISSAO } from 'utils/permissao';

export const verificarOptionsSetores = (cargo, setoresIds) => {
  const retorno = { multiplosSetores: false, opcoesSetores: false };

  if (cargo === ENUM_CARGO.SUPERVISOR) {
    retorno.opcoesSetores = false;
  }
  if (cargo === ENUM_CARGO.SUPERVISOR_SETORIAL) {
    retorno.opcoesSetores = true;
    retorno.multiplosSetores = true;
  }
  if (cargo === ENUM_CARGO.ATENDENTE) {
    retorno.opcoesSetores = true;
  }
  if (cargo === ENUM_CARGO.ATENDENTE && setoresIds?.length > 0) {
    retorno.opcoesSetores = true;
    retorno.multiplosSetores = false;
  }
  return retorno;
};

export const verificarPermissaoEditarApagar = user => {
  return user?.permission.includes(ENUM_PERMISSAO.SUP03.codigo) ? true : false;
};

export const validarCargo = (valorSelecionado, handleChange, setExibirOpcoesSetores, setExibirVariosSetores) => {
  const valoresSalvar = { multiplosSetores: false, opcoesSetores: false };

  if (valorSelecionado === ENUM_CARGO.SUPERVISOR) {
    valoresSalvar.opcoesSetores = false;
    handleChange({ target: { name: 'isSetorial', value: ENUM_STATUS_IS_SETORIAL.NAO.value } });
    handleChange({ target: { name: 'setoresIds', value: [] } });
  } else if (valorSelecionado === ENUM_CARGO.SUPERVISOR_SETORIAL) {
    valoresSalvar.opcoesSetores = true;
    valoresSalvar.multiplosSetores = true;
    handleChange({ target: { name: 'isSetorial', value: ENUM_STATUS_IS_SETORIAL.SIM.value } });
    handleChange({ target: { name: 'setoresIds', value: [] } });
  } else {
    valoresSalvar.opcoesSetores = true;
    valoresSalvar.multiplosSetores = false;
    handleChange({ target: { name: 'isSetorial', value: ENUM_STATUS_IS_SETORIAL.NAO.value } });
    handleChange({ target: { name: 'setoresIds', value: [] } });
  }
  setExibirOpcoesSetores(valoresSalvar.opcoesSetores);
  setExibirVariosSetores(valoresSalvar.multiplosSetores);
  return valoresSalvar;
};

export const filtrarSetores = (optionsSetores, setoresAtendente) => {
  const idSetorUsuarioLogado = setoresAtendente?.map(x => x.id);
  if (idSetorUsuarioLogado?.length > 0) {
    return optionsSetores?.filter(x => idSetorUsuarioLogado.includes(x.value));
  }
  return optionsSetores;
};

export const mensagemCadastrar =
  'Para cadastrar um usuário preencha todas as informações ' +
  'solicitadas, o usuário cadastrado deve ter um usuário no eSefaz ' +
  'antes de realizar seu primeiro acesso.';

export const mensagemCadastrarSetorial = 'O cadastro de novos atendentes, requer aprovação do Supervisor.';

export const mensagemVisualizar = 'Dados do usuário cadastrados no sistema.';

export const getMensagem = (isVisualizar, isSetorial) => {
  if (isVisualizar) {
    return mensagemVisualizar;
  }
  if (isSetorial) {
    return `${mensagemCadastrar} ${mensagemCadastrarSetorial}`;
  }
  return mensagemCadastrar;
};
